import Cookies from "js-cookie";

export default function account() {
  const account = Cookies.get("account");
  if (account != null) {
    return account;
  } else if (active) {
    return "Subscriber";
  } else {
    return false;
  }
}

let active = false;
let req = null;
let rejectQueue = [];
let resolveQueue = [];

/**
 * Fetch active subscriber status over AJAX
 *
 * Restricts to a single AJAX call per page load, will resolve with the true/false
 *
 * @return {Promise}
 */
export function fetchActive(baseURL = null) {
  return new Promise((resolve, reject) => {
    if (active === true) {
      resolve(active);
    } else {
      rejectQueue.push(reject);
      resolveQueue.push(resolve);

      if (!req) {
        const timestamp = Date.now().toString();
        let url = `/account/check-active.json?t=${timestamp}`;
        if (baseURL) {
          url = `${baseURL}${url}`;
        }
        req = fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            accept: "application/json"
          }
        })
          .then(response => {
            // Throw a custom error message
            if (!response.ok) {
              rejectQueue.forEach(cb =>
                cb(console.log("Failed to fetch active state", response))
              );
            } else {
              return response.json();
            }
          })
          .then(data => {
            active = data.active;
            resolveQueue.forEach(cb => cb(active));
          });
      }
    }
  });
}
